import { useTranslation } from "react-i18next";
import {format} from "date-fns";
import {Tooltip} from "primereact/tooltip";
import React, {useEffect, useRef, useState} from "react";




export const getTimeAgo = (timestamp: string) => {
    const createdDate = new Date(timestamp);
    const [t] = useTranslation();
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - createdDate.getTime()) / 1000);

    if (diffInSeconds < 60) return `${diffInSeconds} ${t("notification.seconds")}`;
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes} ${t("notification.minutes")}`;
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours} ${t("notification.hours")}`;
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays} ${t("notification.days")}`;
};

export const DateText = (
    timestamp: string,
    showTooltip: boolean = true,
    showOffset: boolean = false,
    dateFormat: string = "dd-MM-yyyy HH:mm",
): React.ReactNode => {
    let timestampDate = new Date(timestamp);

    const formattedDate = format(timestampDate, dateFormat);
    const utcOffset = getUTCOffset(timestampDate);

    return (
        <>
            {showTooltip && <Tooltip  target="[data-pr-tooltip]" />}
            <span
                {...(showTooltip
                    ? {
                        'data-pr-tooltip': `UTC ${utcOffset}`,
                        'data-pr-position': 'right',
                    }
                    : {})}
            >
                {formattedDate + (showOffset ? utcOffset : '')}
            </span>
        </>
    );
};


export const getUTCOffset = (date: Date) => {
    const offset = -date.getTimezoneOffset();
    const sign = offset >= 0 ? '+' : '-';
    const hours = Math.abs(Math.floor(offset / 60));
    const minutes = Math.abs(offset % 60);
    return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};